import Vue from 'vue'
import Vuex from 'vuex'

import User from './modules/user'
import Loading from './modules/loading'
import Master from './modules/master'
import Property from './modules/property'
import SearchProperty from './modules/search_property'
import SelectProperty from './modules/select_property'
import Column from './modules/column'
import Tag from './modules/tag'
import ConvertProcess from './modules/convert_process'
import ConvertSummary from './modules/convert_summary'
import ModalNewPropertyLinkList from './modules/modal_new_property_link_list'
import ModalSearchByArea from './modules/modal_search_by_area'
import ModalSearchByRailway from './modules/modal_search_by_railway'
import ModalSearchConditions from './modules/modal_search_conditions'
import ModalSearchSave from './modules/modal_search_save'
import ModalHappyCall from './modules/modal_happy_call'
import ModalAuth from './modules/modal_auth'
import ModalPropertyBulkDelete from './modules/modal_property_bulk_delete'
import ModalPropertyCopy from './modules/modal_property_copy'
import ModalConvertError from './modules/modal_convert_error'
import ModalConvertHistory from './modules/modal_convert_history'
import ModalConvertDetail from './modules/modal_convert_detail'
import ModalImagePreview from './modules/modal_image_preview'
import ModalMaisoku from './modules/modal_maisoku'
import ModalPropertyQuickEdit from './modules/modal_property_quick_edit'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    User,
    Loading,
    Master,
    Property,
    SearchProperty,
    SelectProperty,
    Column,
    Tag,
    ConvertProcess,
    ConvertSummary,
    ModalNewPropertyLinkList,
    ModalSearchByArea,
    ModalSearchByRailway,
    ModalSearchConditions,
    ModalSearchSave,
    ModalHappyCall,
    ModalAuth,
    ModalPropertyBulkDelete,
    ModalPropertyCopy,
    ModalConvertError,
    ModalConvertHistory,
    ModalConvertDetail,
    ModalImagePreview,
    ModalMaisoku,
    ModalPropertyQuickEdit,
  },
})
